import React from "react";
import {Icon, Input, Tag, Tooltip, AutoComplete} from "antd";
import {message} from "../view/sysManagement/utils/sysManagementUtils";
const checkColor = "#FF0000"; // 检测敏感词颜色
export class EditableTagGroup extends React.Component {

    state = {
        tagsClosable: this.props.tagsClosable,
        tags: this.props.tags,
        newTagVisible: this.props.newTagVisible,
        inputVisible: false,
        inputValue: '',
    };

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({tags: nextProps.tags, autoCompleteData:nextProps.autoCompleteData});
    }

    handleClose = removedTag => {
        const tags = this.state.tags.filter(tag => tag !== removedTag);
        this.props.syncTagsToSuperclass(tags);
        this.setState({ tags });
    };

    showInput = () => {
        this.setState({ inputVisible: true }, () => this.input?this.input.focus():"");
    };

    handleInputChange = e => {
        this.setState({ inputValue: e.target.value });
    };

    handleInputConfirm = () => {
        const { inputValue } = this.state;
        if(this.props.inputType !== "Input"){
            let error = false;
            this.props.autoCompleteData && this.props.autoCompleteData.map(item=>{
                if(item === inputValue){
                    error = true;
                }
            });
            if(!error){
                message.error(inputValue+"不存在，无法添加！");
                return;
            }
        }

        var isAddTag = true;

        if(this.props.type === 'weibo') {
            // var patrn = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/im;
            var patrn = /[!@#$&*()=:/;?+']/im;
            // 如果包含特殊字符返回false
            if (patrn.test(inputValue))
            {
                isAddTag = false;
                message.error(inputValue+"包含特殊字符，请重新输入！");
            }
        }

        let { tags } = this.state;
        if (inputValue) {
            if(tags.indexOf(inputValue) === -1)
            {
                if(isAddTag)
                {
                    tags = [...tags, inputValue];
                }
            }else{
                message.error(inputValue+"已添加，请勿重复添加！")
            }
        }
        this.props.syncTagsToSuperclass(tags);
        this.props.onChange(tags);
        this.setState({
            tags,
            inputVisible: false,
            inputValue: '',
        });

    };

    saveInputRef = input => (this.input = input);

    render() {
        const { tags, inputVisible, inputValue, newTagVisible, tagsClosable } = this.state;
        const {checkData}=this.props;
        return (
            <div>
                {tags.map((tag, index) => {
                    const isLongTag = tag.length > 20;
                    let color = "";
                    if(checkData?.tags?.length) {
                        if(checkData.tags.some(item=>tag.indexOf(item?.word)>-1)) {
                            color = checkColor
                        }
                    }
                    const tagElem = (
                        <Tag
                            color={color}
                            style={{marginTop: 10}}
                            key={tag}
                            closable={index===0?this.props.firstTagClosable:tagsClosable}
                            onClose={() => this.handleClose(tag)}>
                            {isLongTag ? `${tag.slice(0, 20)}...` : tag}
                        </Tag>
                    );
                    return isLongTag ? (
                        <Tooltip title={tag} key={tag}>
                            {tagElem}
                        </Tooltip>
                    ) : (
                        tagElem
                    );
                })}
                {inputVisible && ( this.props.inputType === "Input"?
                    <Input
                        ref={this.saveInputRef}
                        type="text"
                        size="small"
                        style={{ width: 78,margin:"10px 10px 10px 0px" }}
                        value={inputValue}
                        onChange={(e)=>this.handleInputChange(e)}
                        onBlur={()=>this.handleInputConfirm()}
                        onPressEnter={()=>this.handleInputConfirm()}
                        maxLength={10}
                    />:<AutoComplete
                            autoFocus
                            style={{ width: "150px" }}
                            dataSource={this.props.autoCompleteData}
                            onChange={(inputValue)=>this.setState({ inputValue})}
                            onBlur={()=>this.handleInputConfirm()}
                            onPressEnter={()=>this.handleInputConfirm()}
                            filterOption={(inputValue, option) =>
                                this.props.autoCompleteFilterOption(inputValue, option)
                            }
                        />
                )}
                {!inputVisible && newTagVisible && (
                    <Tag onClick={this.showInput} style={{ background: '#fff', borderStyle: 'solid',margin:"10px 10px 10px 0px", cursor: "pointer"}}>
                         {this.props.newTagText}
                    </Tag>
                )}
            </div>
        );
    }
}
EditableTagGroup.defaultProps = {
    tags: [],
    onChange: tags=>void(tags),
	syncTagsToSuperclass: tags=>void(tags),
    newTagVisible: true,
    tagsClosable: true,
    newTagText: "#添加标签",
    inputType: "Input",
    firstTagClosable:true,
    autoCompleteData:[],
    autoCompleteFilterOption:(inputValue, option)=>{}
};